export const sitePages = [
  {
    text: "Page Home",
    value: "/",
  },
];
